import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, mergeProps as _mergeProps } from "vue"

import { defineComponent, ref, toRefs } from "vue";
import dayjs, { Dayjs } from "dayjs";

export default /*#__PURE__*/_defineComponent({
  __name: 'CheckPosDetailInfo',
  props: {
  idTypeDicList: Array,
  planPackageDicList: Array,
  genderDicList: Array,
  bankDicList: Array,
  branchDicList: Array,
  relationDicList: Array,
},
  setup(__props, { expose: __expose }) {

const open = ref<boolean>(false);
const detailInfo = ref<any>();
const props = __props;
const {
  idTypeDicList,
  planPackageDicList,
  genderDicList,
  bankDicList,
  branchDicList,
  relationDicList,
} = toRefs(props);
const birthDate = ref<Dayjs>();
const startDate = ref<Dayjs>();
const showModal = (record: any) => {
  detailInfo.value = record;
  console.log(
    "%c [ record ]-156",
    "font-size:13px; background:pink; color:#bf2c9f;",
    record
  );
  birthDate.value = dayjs(detailInfo.value.insuredBirth, "YYYY-MM-DD");
  startDate.value = dayjs(detailInfo.value.startTime, "YYYY-MM-DD");
  open.value = true;
};

const handleOk = (e: MouseEvent) => {
  open.value = false;
};
__expose({
  showModal,
});

return (_ctx: any,_cache: any) => {
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_date_picker = _resolveComponent("a-date-picker")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_a_modal, {
      open: open.value,
      "onUpdate:open": _cache[16] || (_cache[16] = ($event: any) => ((open).value = $event)),
      title: "员工信息",
      onOk: handleOk,
      width: "600px",
      style: {}
    }, {
      default: _withCtx(() => [
        _createVNode(_component_a_form, _mergeProps({ style: {"width":"400px","margin":"0 auto"} }, {
          labelCol: { span: 5 },
          wrapperCol: { span: 16 },
        }), {
          default: _withCtx(() => [
            _createVNode(_component_a_form_item, { label: "姓名" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input, {
                  value: detailInfo.value.insuredName,
                  "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((detailInfo.value.insuredName) = $event)),
                  disabled: true
                }, null, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, { label: "证件类型" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_select, {
                  ref: "select",
                  value: detailInfo.value.insuredIdType,
                  "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((detailInfo.value.insuredIdType) = $event)),
                  disabled: true
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(idTypeDicList), (foo) => {
                      return (_openBlock(), _createBlock(_component_a_select_option, {
                        key: foo.code
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(foo.name), 1)
                        ]),
                        _: 2
                      }, 1024))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, { label: "证件号" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input, {
                  value: detailInfo.value.insuredIdNum,
                  "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((detailInfo.value.insuredIdNum) = $event)),
                  disabled: true
                }, null, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, { label: "出生日期" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_date_picker, {
                  value: birthDate.value,
                  "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((birthDate).value = $event)),
                  disabled: true
                }, null, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, { label: "性别" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_select, {
                  ref: "select",
                  value: detailInfo.value.insuredGender,
                  "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((detailInfo.value.insuredGender) = $event)),
                  disabled: true
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(genderDicList), (foo) => {
                      return (_openBlock(), _createBlock(_component_a_select_option, {
                        key: foo.code
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(foo.name), 1)
                        ]),
                        _: 2
                      }, 1024))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, { label: "社保地" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input, {
                  value: detailInfo.value.socialSecurityArea,
                  "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((detailInfo.value.socialSecurityArea) = $event)),
                  disabled: true
                }, null, 8, ["value"])
              ]),
              _: 1
            }),
            (detailInfo.value.contractPersonalHasWorkPlace)
              ? (_openBlock(), _createBlock(_component_a_form_item, {
                  key: 0,
                  label: "工作地"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_input, {
                      value: detailInfo.value.workPlace,
                      "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((detailInfo.value.workPlace) = $event)),
                      disabled: true
                    }, null, 8, ["value"])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            _createVNode(_component_a_form_item, { label: "人员类别" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_select, {
                  ref: "select",
                  value: detailInfo.value.relation,
                  "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => ((detailInfo.value.relation) = $event)),
                  disabled: true
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(relationDicList), (foo) => {
                      return (_openBlock(), _createBlock(_component_a_select_option, {
                        key: foo.code
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(foo.name), 1)
                        ]),
                        _: 2
                      }, 1024))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, { label: "所属员工" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input, {
                  value: detailInfo.value.employeeName,
                  "onUpdate:value": _cache[8] || (_cache[8] = ($event: any) => ((detailInfo.value.employeeName) = $event)),
                  disabled: true
                }, null, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, { label: "员工证件号" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input, {
                  value: detailInfo.value.employeeIdNum,
                  "onUpdate:value": _cache[9] || (_cache[9] = ($event: any) => ((detailInfo.value.employeeIdNum) = $event)),
                  disabled: true
                }, null, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, { label: "分公司" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_select, {
                  ref: "select",
                  value: detailInfo.value.branchId,
                  "onUpdate:value": _cache[10] || (_cache[10] = ($event: any) => ((detailInfo.value.branchId) = $event)),
                  disabled: true
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(branchDicList), (foo) => {
                      return (_openBlock(), _createBlock(_component_a_select_option, {
                        key: foo.code
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(foo.name), 1)
                        ]),
                        _: 2
                      }, 1024))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, { label: "手机号" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input, {
                  value: detailInfo.value.employeePhone,
                  "onUpdate:value": _cache[11] || (_cache[11] = ($event: any) => ((detailInfo.value.employeePhone) = $event)),
                  disabled: true
                }, null, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, { label: "邮箱" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input, {
                  value: detailInfo.value.employeeEmail,
                  "onUpdate:value": _cache[12] || (_cache[12] = ($event: any) => ((detailInfo.value.employeeEmail) = $event)),
                  disabled: true
                }, null, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, { label: "工号" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input, {
                  value: detailInfo.value.employeeJobNumber,
                  "onUpdate:value": _cache[13] || (_cache[13] = ($event: any) => ((detailInfo.value.employeeJobNumber) = $event)),
                  disabled: true
                }, null, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, { label: "保障方案" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_select, {
                  ref: "select",
                  value: detailInfo.value.planPackageId,
                  "onUpdate:value": _cache[14] || (_cache[14] = ($event: any) => ((detailInfo.value.planPackageId) = $event)),
                  disabled: true
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(planPackageDicList), (foo) => {
                      return (_openBlock(), _createBlock(_component_a_select_option, {
                        key: foo.code
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(foo.name), 1)
                        ]),
                        _: 2
                      }, 1024))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, { label: "生效日期" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_date_picker, {
                  value: startDate.value,
                  "onUpdate:value": _cache[15] || (_cache[15] = ($event: any) => ((startDate).value = $event)),
                  disabled: true
                }, null, 8, ["value"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 16)
      ]),
      _: 1
    }, 8, ["open"])
  ]))
}
}

})